import AuthBaseRepository from '@/api/misc/AuthBaseRepository';
import { AxiosResponse } from 'axios';

export default class AuthRepository extends AuthBaseRepository {

    public getIncompleteUser(): Promise<AxiosResponse> {
        const json = {
            emailDomain: process.env!.VUE_APP_INCOMPLETE_USER_EMAIL_DOMAIN
        };
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'incompleteReaderAdd');
        urlencoded.append('json', JSON.stringify(json));
        return this.axiosClient.post(this.endpointDefault, urlencoded);
    }

    public async login(payload: { email: string, password: string, referrer: string, token?: string, fingerprint: string }): Promise<AxiosResponse> {
        // add default params
        const json = {
            client: this.clientType,
            version: this.apiVersion,
            ...payload
        };
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'readerLogin');
        urlencoded.append('json', JSON.stringify(json));
        return this.axiosClient.post(this.endpointDefault, urlencoded);
    }

    public logout(): Promise<AxiosResponse> {
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'logout');
        return this.axiosClient.post(this.endpointDefault, urlencoded);
    }

    /**
     * Makes an localization request
     * The following values can be returned:
     *      code: 511, "you are in the given location."
     *      code: 501, "you are near a location."
     *      code: 510, "you are not in the given location."
     *      code: 500, "you are not near a location."
     *      code: 520, "your token is invalid"
     * @param position
     */
    public localization(payload: { fingerprint: string, id_location?: string }): Promise<AxiosResponse> {
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'Localization.check');
        urlencoded.append('json', JSON.stringify(payload));
        return this.axiosClient.post(this.endpointLocalization, urlencoded);
    }

    public getTokenInformation(payload: { token: string, fingerprint: string }): Promise<AxiosResponse> {
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'checkTokenForUsage');
        urlencoded.append('json', JSON.stringify(payload));
        return this.axiosClient.post(this.endpointDefault, urlencoded);
    }
}
